<script lang="ts">
  import { onMount } from 'svelte';
  import Router, { push } from 'svelte-spa-router';
  import { auth, loadAuth } from '$lib/stores/auth.svelte';
  import routes from './routes';

  onMount(async () => {
    await loadAuth();
    // Si tras cargar /me no hay user y la ruta inicial no es /login,
    // mandamos a /login. (svelte-spa-router lee location de
    // window.location.hash.)
    const currentHash = window.location.hash || '#/';
    if (!auth.user && !currentHash.startsWith('#/login')) {
      push('/login');
    }
  });

  function onConditionsFailed() {
    // requireAuth fallo: redirect a /login.
    push('/login');
  }
</script>

{#if auth.loading}
  <div class="boot">
    <div class="spinner" aria-label="Loading..."></div>
  </div>
{:else}
  <Router {routes} on:conditionsFailed={onConditionsFailed} />
{/if}

<style>
  .boot {
    min-height: 100vh;
    display: grid;
    place-items: center;
    font-family: system-ui, -apple-system, sans-serif;
    background: #f7f7f8;
  }
  .spinner {
    width: 32px;
    height: 32px;
    border: 3px solid #e5e5e5;
    border-top-color: #1a1a1a;
    border-radius: 50%;
    animation: spin 0.7s linear infinite;
  }
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
</style>
